export function LineSeparator() {
    return (
        <>
            <hr style={{height:3, borderWidth:0, color: "rgb(210,210,210)",backgroundColor: "rgb(210,210,210)"}} />
        </>
    );
}